import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "lower-header padding-h-standard" }
const _hoisted_2 = {
  key: 0,
  class: "lower-header-link-disabled"
}

import { PropType } from "vue";

import { HeaderNavigationLink } from "@/models/header.model";

import HeaderLink from "@/components/header/HeaderLink.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LowerHeader',
  props: {
  links: {
    required: true,
    type: Array as PropType<HeaderNavigationLink[]>
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.links, (link) => {
      return (_openBlock(), _createElementBlock("span", {
        key: link.title
      }, [
        (!link.isEnabled)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(link.title), 1))
          : (_openBlock(), _createBlock(HeaderLink, {
              key: 1,
              link: link
            }, null, 8, ["link"]))
      ]))
    }), 128))
  ]))
}
}

})